// User service
import { apiRequest } from "./api";

export const userService = {
  getUsers: async () => {
    return await apiRequest("/users", {
      method: "GET",
      requiresAuth: true,
    });
  },

  createUser: async (fullName, email, password, role = "user") => {
    return await apiRequest("/users", {
      method: "POST",
      requiresAuth: true,
      body: JSON.stringify({ fullName, email, password, role }),
    });
  },

  updateUserRole: async (userId, role) => {
    return await apiRequest(`/users/${userId}`, {
      method: "PATCH",
      requiresAuth: true,
      body: JSON.stringify({ role }),
    });
  },

  deleteUser: async (userId) => {
    return await apiRequest(`/users/${userId}`, {
      method: "DELETE",
      requiresAuth: true,
    });
  },
};
